export function downloadByteArray(reportName: string, byte: Uint8Array) {
  const blob = new Blob([byte]);
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  const fileName = reportName;
  link.download = fileName;
  link.click();
}
